// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { BookOpen, Wrench } from 'lucide-react';

/**
 * Shared "area" config (Congregação x Manutenção) consumed by Layout,
 * DocumentsPage and other surfaces. Keep classnames consistent across the app.
 */
export const AREA_CONFIG = {
  congregacao: {
    name: 'Contas da Congregação',
    fullName: 'Contas da Congregação',
    shortName: 'Congregação',
    icon: BookOpen,
    color: 'text-congregation',
    bgColor: 'bg-congregation-soft',
    borderColor: 'border-congregation-border',
  },
  manutencao: {
    name: 'Contas da Manutenção',
    fullName: 'Contas da Manutenção',
    shortName: 'Manutenção',
    icon: Wrench,
    color: 'text-maintenance',
    bgColor: 'bg-maintenance-soft',
    borderColor: 'border-maintenance-border',
  },
};

export const DEFAULT_AREA = 'congregacao';
